import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../../common/api/request';

export interface Cn54bisCn56ResetRowParams {
  sendingPpo: string;
  receivingPpo: string;
  year: number;
  mailCategory: string;
  rowTypeId: number;
}

interface UseCn54bisCn56ResetRowOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

/**
 * Hook for resetting a specific CN54bis CN56 row
 * 
 * @param options Success and error callback options
 * @returns Mutation hook for resetting a specific row
 */
export const useCn54bisCn56ResetRow = (options?: UseCn54bisCn56ResetRowOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: Cn54bisCn56ResetRowParams) => {
      console.log('Making API request to reset CN54bis CN56 row');
      console.log('Parameters:', JSON.stringify(params, null, 2));
      
      const response = await axios.delete('/cn54bis-cn56-bilateral/by-summary-row', {
        params: {
          sendingPpo: params.sendingPpo,
          receivingPpo: params.receivingPpo,
          year: params.year,
          mailCategory: params.mailCategory,
          rowTypeId: params.rowTypeId,
        },
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      console.log('Reset row API Response:', response);
      return response.data;
    },
    onSuccess: (data, variables) => {
      // Invalidate relevant queries to refetch the updated data
      queryClient.invalidateQueries({ 
        queryKey: ['cn54bis-cn56-summary'] 
      });
      
      // Call the provided success callback
      options?.onSuccess?.(data);
    },
    onError: (error: any) => {
      console.error('Reset row API Error Details:', error);
      if (error?.response) {
        console.error('Error Response:', error.response);
        console.error('Error Data:', error.response.data);
        console.error('Error Status:', error.response.status);
        console.error('Error Headers:', error.response.headers);
      }
      
      // Call the provided error callback
      options?.onError?.(error);
    }
  });
};
